import { render, staticRenderFns } from "./statementAssets.vue?vue&type=template&id=aa98ac30&scoped=true"
import script from "./statementAssets.vue?vue&type=script&lang=js"
export * from "./statementAssets.vue?vue&type=script&lang=js"
import style0 from "./statementAssets.vue?vue&type=style&index=0&id=aa98ac30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa98ac30",
  null
  
)

export default component.exports